import React from "react";
import Banner from "./Banner";
//import BrandShowcase from "./BrandShowcase";
import ContactPitchCards from "./ContactPitchCards";
import ServiceCards from "./ServiceCards";
import ContactForm from "../Pages/ContactForm";


const Homepage = () => {
  return (
    <div>
      <Banner />
      {/* <BrandShowcase /> */}
      <ContactPitchCards/>
      <ServiceCards/>
      <ContactForm/>
      
    </div>
  );
};

export default Homepage;
